import { render, staticRenderFns } from "./Conformity.vue?vue&type=template&id=23e37da4&scoped=true&"
import script from "./Conformity.vue?vue&type=script&lang=js&"
export * from "./Conformity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e37da4",
  null
  
)

export default component.exports